





















































import { Component, Vue, Prop } from "vue-property-decorator";
import { AppContainer, TYPES } from "@/app/index";
import { AppStateService, SecurityService, ConfigService } from "@/services";
import { Branding } from "@/models";

@Component({})
export default class App extends Vue {
  private appStateService: AppStateService = AppContainer.get<AppStateService>(TYPES.Services.AppStateService);
  private configService: ConfigService = AppContainer.get<ConfigService>(TYPES.Services.ConfigService);
  private BrandingType: number = 0;
  private Branding = Branding;

  public beforeUpdate(): void {
    this.setBranding();
  }

  private setBranding() {
    if (this.BrandingType === 0) {
      var currentURL = window.location.hostname.toLowerCase();

      switch (true) {
        case this.configService.Config.BrandingURLBES !== "" && currentURL.includes(this.configService.Config.BrandingURLBES):
          this.BrandingType = this.Branding.BES;
          break;
        case this.configService.Config.BrandingURLVulcan !== "" && currentURL.includes(this.configService.Config.BrandingURLVulcan):
        case this.$route.query.branding && this.$route.query.branding.toString().toLowerCase() === "vulcan":
          this.BrandingType = this.Branding.Vulcan;
          break;
        default:
          this.BrandingType = this.Branding.BES;
          break;
      }
    }
  }
}
